module.exports = __webpack_public_path__ + "static/media/campaign.ee8ed07f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/campaign.svg
// module id = 320
// module chunks = 1